// extracted by mini-css-extract-plugin
export default {"noResult":"NoResult_noResult__NRfJA","noResultIcon":"NoResult_noResultIcon__gTmgs","title":"NoResult_title__SN05t","des":"NoResult_des__v+LvA","search":"NoResult_search__rfy2m"};